import { Wrap } from 'components/Common';
import styled from 'styled-components';

export const GuideBackgroundBlock = styled.div`
  width: 100%;
  max-width: 1528px;
  height: 631px;
  display: flex;
  gap: 80px;
  padding: 146px 164px 149px 124px;
  box-sizing: border-box;
  align-items: center;

  @media (max-width: 1279px) {
    flex-direction: column;
    height: auto;
    gap: 24px;
    padding: 40px 20px;
    align-items: flex-start;
  }
`;

export const ContractManagementBlock = styled(Wrap)`
  width: 100%;
  max-width: 790px;
  border-radius: 10px;
  background: ${({ theme }) => theme.color.PastelRed};
  display: flex;
  flex-direction: column;
  align-items: start;
`;

export const LinkButton = styled.a`
  border-radius: 36px;
  padding: 13.5px 20px;
  text-decoration: none;
  cursor: pointer;
  background-color: rgba(255, 45, 46, 1);
`;
